import React, { useCallback, useState } from "react"
import { InlineButtons } from "@tenforce/product-fields"

import { GlobalState } from "../../../../store"
import { useAppDispatch, useAppSelector } from "../../../../hooks"

import HTMLAndInternalLinkParser from "../common/HTMLAndInternalLinkParser"
import { executeAction } from "../../../scripting/slice"
import { IInlineButtonsField } from "../../index"

export interface Props {
    field: IInlineButtonsField
}

export const InlineButtonsField = ({ field }: Props): JSX.Element => {
    const dispatch = useAppDispatch()
    const { isLoading } = useAppSelector((state: GlobalState) => state.fields)
    const {
        position: _position,
        odataType: _odataType,
        value,
        itemId,
        description,
        ...fieldProps
    } = field

    const [loadingActions, setLoadingActions] = useState<
        Record<string, boolean>
    >({})

    const localActions = value
        .filter((action) => {
            return !!action.id
        })
        .map((action) => {
            return {
                ...action,
                onClick: () => handleClick(action.id ?? ""),
                isLoading: loadingActions[action.id ?? ""],
            }
        })

    const handleClick = useCallback(
        async (id: string): Promise<void> => {
            setLoadingActions({ ...loadingActions, [id]: true })
            await dispatch(
                executeAction({
                    action: id,
                    itemId: field.itemId,
                    fieldId: field.fieldId,
                }),
            )
            setLoadingActions({ ...loadingActions, [id]: false })
        },
        [localActions],
    )

    return (
        <InlineButtons
            {...fieldProps}
            description={
                <HTMLAndInternalLinkParser
                    content={(description as string) ?? ""}
                />
            }
            actions={localActions}
            isLoading={isLoading ?? false}
        />
    )
}

export default InlineButtonsField
